import React from 'react'
import { withRouter } from 'react-router-dom'

class PurchaseModal extends React.Component {
    state = {
        quantity: 1,
        game: null,
        quantityError: false,
    }

    constructor(props) {
        super(props)
        this.modalRef = React.createRef()
    }

    handleKeyPress = (e) => {
        if (e.key === 'Escape') {
            this.props.onClose()
        }
    }

    handleClickOutside = (e) => {
        if (this.modalRef.current && !this.modalRef.current.contains(e.target)) {
            this.props.onClose()
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress)
        document.addEventListener('mousedown', this.handleClickOutside)

        const { game } = this.props;
        this.setState({ game })

        if (window.fbq) {
            window.fbq('track', 'ViewContent');
        } else {
            console.warn('Facebook Pixel not initialized');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && (!prevProps.isOpen || prevProps.game?.id !== this.props.game?.id)
        ) {
            const { game } = this.props;
            this.setState({ game, quantity: game.minimum_purchase });
        }
      }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress)
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    redirectToCheckout = (quantity) => {
        const { game, history } = this.props
        if (!quantity || !game?.id) return
        const gameId = game?.id

        if (!quantity || !gameId) return

        history.push({
            pathname: '/checkout',
            search: `?quantity=${quantity}&game=${gameId}`,
            state: {
                price: game.price,
                title: game.title,
            },
        })

    }

    handleCustomPurchase = () => {
        const { quantity } = this.state
        const { game, history } = this.props

        let customQuantity = Number(quantity)
        if (customQuantity < game?.minimum_purchase) {
            //customQuantity = game?.minimum_purchase
            this.setState({ quantityError: true })
            return
        }

        if (customQuantity > game?.available) {
            //customQuantity = game?.available
            this.setState({ quantityError: true })
            return
        }

        this.setState({ ...this.state, quantityError: false })

        history.push({
            pathname: '/checkout',
            search: `?quantity=${customQuantity}&game=${game.id}`,
            state: {
                price: game.price,
                title: game.title,
            },
        })
      }


    render() {
        const { isOpen, onClose, game } = this.props

        if (!isOpen || !this.state.game) return null

        return (
            <div className="modal-overlay">
                <div className="modal-content" ref={this.modalRef}>
                    <button className="modal-close" onClick={onClose}>×</button>
                    <h3 className="text-center mb-4">{game?.title}</h3>
                    <h3 className="text-center mb-4 text-uppercase">Ingresa la cantidad o Elige un paquete</h3>
                    <p className="text-center mb-4">Valor de la unidad ${game.price}</p>

                    <div className="purchase-grid">
                        <div className="custom-box">
                            <p className="desc">{this.state.quantityError ?
                                'Compra minina ' + this.state.game?.minimum_purchase + ' números, máxima ' + this.state.game?.available + ' números.' :
                                'Agrega la cantidad de números que desees.'
                            }</p>
                            <div className="d-flex align-items-center gap-2 mt-2">
                                <input
                                    type="text"
                                    className="custom-input"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={this.state.quantity}
                                    onChange={(e) => {
                                        /*const min = this.state.game?.minimum_purchase || 1
                                        const max = this.state.game?.available || 100*/
                                        if (/^\d*$/.test(e.target.value)) {
                                            let value = Number(e.target.value)
                                            this.setState({ quantity: value })

                                            if (value < this.state.game?.minimum_purchase || value > this.state.game?.available) {
                                                this.setState({ quantityError: true })
                                            }
                                        }
                                        /*if (value < min) value = min
                                        if (value > max) value = max*/
                                    }}
                                />
                                <button
                                    className="buy-btn"
                                    onClick={this.handleCustomPurchase}
                                    disabled={this.state.quantity < this.state.game?.minimum_purchase || this.state.quantity > this.state.game?.available}
                                >
                                    COMPRAR
                                </button>
                            </div>
                        </div>
                        
                        {[5, 10, 15, 20, 25, 30].filter(n => n >= this.state.game?.minimum_purchase).map((qty, i) => (
                            <div key={qty} className={`purchase-box ${qty === 20 ? 'highlight' : ''}`}>
                                {qty === 20 && <span className="badge">🔥 Más Vendido 🔥</span>}
                                <h4 className="title">X{qty} NÚMEROS</h4>
                                <p className="price">${qty* game.price}</p>
                                <button
                                    className="buy-btn"
                                    disabled={!(this.state.game.available >= qty)}
                                    onClick={() => this.redirectToCheckout(qty)}
                                >
                                    COMPRAR
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(PurchaseModal)
